import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { adminApi, brl, errMsg } from "@/lib/api";
import { ReferralConfigCard } from "@/components/admin/referrals/ReferralConfigCard";
import { ReferralPayouts } from "@/components/admin/referrals/ReferralPayouts";

function ReferrersTable() {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => adminApi.get("/referrals/referrers").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  const toggle = async (r, on) => {
    try { await adminApi.patch(`/referrals/referrers/${r.id}`, { status: on ? "active" : "inactive" }); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="card-surface overflow-x-auto" data-testid="admin-referrers">
      <p className="eyebrow p-5 pb-2">Indicadores ({rows.length})</p>
      {!rows.length ? <p className="px-5 pb-8 text-center text-sm text-muted-foreground">Nenhum indicador ainda.</p> : (
        <Table>
          <TableHeader><TableRow><TableHead>Nome</TableHead><TableHead>Tipo</TableHead><TableHead>Código</TableHead><TableHead>Chave Pix</TableHead><TableHead>Indicações ativas</TableHead><TableHead>Comissões</TableHead><TableHead>Ativo</TableHead></TableRow></TableHeader>
          <TableBody>{rows.map((r) => (
            <TableRow key={r.id} data-testid={`admin-referrer-${r.id}`}>
              <TableCell><p className="font-medium">{r.name}</p><p className="text-xs text-muted-foreground">{r.email}</p></TableCell>
              <TableCell><Badge variant="outline">{r.kind === "tenant" ? "Cliente" : "Parceiro"}</Badge></TableCell>
              <TableCell className="font-mono text-xs">{r.code}</TableCell>
              <TableCell className="font-mono text-xs">{r.pix_key || "—"}</TableCell>
              <TableCell>{r.active_referrals} / {r.referrals}</TableCell>
              <TableCell className="font-mono">{brl(r.total_commission)}</TableCell>
              <TableCell><Switch checked={r.status === "active"} onCheckedChange={(v) => toggle(r, v)} data-testid={`admin-referrer-status-${r.id}`} /></TableCell>
            </TableRow>
          ))}</TableBody>
        </Table>
      )}
    </div>
  );
}

export function ReferralsTab() {
  return (
    <div className="space-y-6" data-testid="admin-referrals-tab">
      <ReferralConfigCard />
      <ReferralPayouts />
      <ReferrersTable />
    </div>
  );
}
